// extracted by mini-css-extract-plugin
module.exports = {"kyc":"kyc_kyc__kgJbA","kyc__title":"kyc_kyc__title__NakiC","kyc__error":"kyc_kyc__error__DUM_t"};